import React, { useEffect } from 'react'
import { RECAPTCHA_SITEKEY } from 'Config/config'
import { _Recaptcha } from './styles'

export const Recaptcha = () => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITEKEY}`
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])
  return (
    <_Recaptcha>
      <span>
        This site is protected by reCAPTCHA and the Google&nbsp;
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        &nbsp;&amp;&nbsp;
        <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">
          Terms of Service
        </a>&nbsp;apply.
      </span>
    </_Recaptcha>
  )
}

export default Recaptcha
